module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-6-db7c8401ea04a2e7c5bb9bb4826c8df6.webp";